import { createReducer } from '@reduxjs/toolkit';
import { getSectionOpacity } from '@utils/functions.js';

import * as promoBarActions from './promoBarActions.js';

const initialState = {
  id: 0,
  uid: 0,
  type: 'promo',
  isActive: false,
  isAdded: false,

  message: '',
  color: '#000',
  textSize: '14',
  isMasterPromobar: false,
  animation: 'none',
  actionType: '',
  opacity: 0,

  ctaSite: '',
  ctaSiteText: 'View on Website',
  ctaLinkId: 0,
  ctaBlockId: 0,
  ctaOpacity: 0,
  ctaTextColor: '#000000',
  ctaBackgroundColor: '#f3a327',
  ctaBackgroundColorRGBA: '',
  ctaBorder: 'none',
  ctaBorderColor: '#ECECF0',
  ctaShadow: 'none',
  ctaShadowColor: '#000000',
  ctaShape: 'square',

  requesting: false,
  error: null,
};

const promoBar = createReducer(initialState, (builder) => {
  builder
    .addCase(promoBarActions.promoBarUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(promoBarActions.promoBarUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(promoBarActions.promoBarUpdateStore, (state) => ({ ...state, requesting: false, error: null }))

    .addCase(promoBarActions.promoBarStore, (state, { payload }) => {
      const { uid, isActive, data } = payload;

      const section = data ?? {};
      const {
        id,

        message,
        color,
        promobarOpacity,
        textSize,
        isMaster,
        textAnimation,

        ctaType,
        ctaBackgroundColor,
        ctaBackgroundRGBA,
        ctaItemId,
        ctaBlockId,
        ctaOpacity,
        ctaSite,
        ctaSiteText,
        ctaTextColor,
        ctaBorder,
        ctaBorderColor,
        ctaShadow,
        ctaShadowColor,
        ctaShape,
      } = section;

      return {
        ...state,

        id: id ?? 0,
        uid: uid ?? 0,
        isActive,
        isAdded: Boolean(id),

        message: message ?? '',
        color: color ?? '#000',
        opacity: promobarOpacity ?? 0,
        textSize: textSize ?? '14',
        isMasterPromobar: isMaster ?? false,
        animation: textAnimation ?? 'none',
        actionType: ctaType ?? '',

        ctaSite: ctaSite ?? '',
        ctaSiteText: ctaSiteText ?? 'View on Website',
        ctaLinkId: ctaItemId ?? 0,
        ctaBlockId: ctaBlockId ?? 0,
        ctaOpacity: ctaOpacity !== null ? getSectionOpacity(ctaOpacity) : 0,
        ctaTextColor: ctaTextColor ?? '#000000',
        ctaBackgroundColor: ctaBackgroundColor ?? '#f3a327',
        ctaBackgroundColorRGBA: ctaBackgroundRGBA ?? '',
        ctaBorder: ctaBorder ?? 'none',
        ctaBorderColor: ctaBorderColor ?? '#000000',
        ctaShadow: ctaShadow ?? 'none',
        ctaShadowColor: ctaShadowColor ?? '#000000',
        ctaShape: ctaShape ?? 'square',

        error: null,
        requesting: false,
      };
    })

    .addCase(promoBarActions.promoBarClear, () => ({ ...initialState }))

    .addCase(promoBarActions.promoBarUpdateId, (state, { payload: id }) => ({ ...state, id }))
    .addCase(promoBarActions.promoBarUpdateIsAdded, (state, { payload: isAdded }) => ({ ...state, isAdded }))
    .addCase(promoBarActions.promoBarUpdateIsActive, (state, { payload: isActive }) => ({ ...state, isActive }))

    .addCase(promoBarActions.promoBarUpdateMessage, (state, { payload: message }) => ({ ...state, message }))
    .addCase(promoBarActions.promoBarUpdateColor, (state, { payload: color }) => ({ ...state, color }))
    .addCase(promoBarActions.promoBarUpdateOpacity, (state, { payload: opacity }) => ({ ...state, opacity }))
    .addCase(promoBarActions.promoBarUpdateTextSize, (state, { payload: textSize }) => ({ ...state, textSize }))
    .addCase(promoBarActions.promoBarUpdateAnimation, (state, { payload: animation }) => ({ ...state, animation }))
    .addCase(promoBarActions.promoBarIsMaster, (state, { payload: isMasterPromobar }) => ({ ...state, isMasterPromobar }))
    .addCase(promoBarActions.promoBarUpdateActionType, (state, { payload: actionType }) => ({ ...state, actionType }))

    .addCase(promoBarActions.promoBarUpdateCTASite, (state, { payload: ctaSite }) => ({ ...state, ctaSite }))
    .addCase(promoBarActions.promoBarUpdateCTASiteText, (state, { payload: ctaSiteText }) => ({ ...state, ctaSiteText }))
    .addCase(promoBarActions.promoBarUpdateCTALinkId, (state, { payload: ctaLinkId }) => ({ ...state, ctaLinkId }))
    .addCase(promoBarActions.promoBarUpdateCTABlockId, (state, { payload: ctaBlockId }) => ({ ...state, ctaBlockId }))
    .addCase(promoBarActions.promoBarUpdateCTAOpacity, (state, { payload: ctaOpacity }) => ({ ...state, ctaOpacity }))
    .addCase(promoBarActions.promoBarUpdateCTATextColor, (state, { payload: ctaTextColor }) => ({ ...state, ctaTextColor }))
    .addCase(promoBarActions.promoBarUpdateCTABackgroundColor, (state, { payload: ctaBackgroundColor }) => ({ ...state, ctaBackgroundColor }))
    .addCase(promoBarActions.promoBarUpdateCTABackgroundColorRGBA, (state, { payload: ctaBackgroundColorRGBA }) => ({ ...state, ctaBackgroundColorRGBA }))
    .addCase(promoBarActions.promoBarUpdateCTABorder, (state, { payload: ctaBorder }) => ({ ...state, ctaBorder }))
    .addCase(promoBarActions.promoBarUpdateCTABorderColor, (state, { payload: ctaBorderColor }) => ({ ...state, ctaBorderColor }))
    .addCase(promoBarActions.promoBarUpdateCTAShadow, (state, { payload: ctaShadow }) => ({ ...state, ctaShadow }))
    .addCase(promoBarActions.promoBarUpdateCTAShadowColor, (state, { payload: ctaShadowColor }) => ({ ...state, ctaShadowColor }))
    .addCase(promoBarActions.promoBarUpdateCTAShape, (state, { payload: ctaShape }) => ({ ...state, ctaShape }));
});

export default promoBar;
